import { React, Modal, Heading, Button, Text } from 'mondrian-react';
import styles from './styles.module.css';

function ModalFonts(props) {
  const { open, close } = props;

  return (
    <div>
      {/* BaseComponent Code Start */}
      <Modal
        data={{
          header: <Heading md>Fontes</Heading>,
          content: (
            <div>
              <Text body className={styles.ModalFonts}>
                Para aumentar ou reduzir a fonte, utilize os atalhos nativos do
                seu navegador.
              </Text>
              <br />
              <Text body className={styles.ModalFonts}>
                <span>
                  - No windows <b>Control+</b> (para aumentar) e <b>Control-</b>{' '}
                  (para diminuir)
                </span>
              </Text>
              <br />
              <Text body className={styles.ModalFonts}>
                <span>
                  - No macOS (safari) <b>cmd+</b> (para aumentar) e <b>cmd-</b>{' '}
                  (para diminuir)
                </span>
              </Text>
            </div>
          ),
          footer: {
            action: (
              <Button primary onClick={close}>
                Ok
              </Button>
            ),
          },
          isOpen: open,
          onCloseClick: close,
        }}
      />
      {/* BaseComponent Code End */}
    </div>
  );
}

export default ModalFonts;
